// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Email.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { toJS, observable, action } from 'mobx';
import { ATTACH_TYPE_OPTIONS, DELIVERY_METHOD, EMAIL_TYPE } from 'logic/data/Izenda.EmailConstants';
import { trim } from 'lodash/fp';

class Email {
  @observable to = '';
  @observable cc = '';
  @observable subject = '';
  @observable deliveryMethod = DELIVERY_METHOD.link;
  @observable attachmentType = ATTACH_TYPE_OPTIONS[2].value;
  @observable body = '';
  @observable type = EMAIL_TYPE.report;

  /**
   * Set email properties by key
   * @param {string} key
   * @param {string} value
   */
  setDataByKey(key: string, value: string) {
    this[key] = value;
  }

  /**
   * Replace email body's new line by br tag in html
   * @returns {object}
   */
  buildForSend() {
    const email = toJS(this);
    email.body = email.body.replace(/\n/g, '<br>');
    return email;
  }

  /**
   * Set email body
   * @param {string} emailBody 
   */
  setEmailBody(emailBody: string) {
    const normalizeEmailBody = emailBody && emailBody.split(/<br\/?>/).map(trim).join('\n');
    this.setDataByKey('body', normalizeEmailBody);
  }

  /**
   * Set delivery method
   * @param {string} emailBody
   * @param {string} value
   */
  @action
  setDeliveryMethod(emailBody: string, value: string) {
    this.setDataByKey('deliveryMethod', value);
    this.setEmailBody(emailBody);
  }
}

export default Email;



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Email.js